// extracted by mini-css-extract-plugin
module.exports = {"iddleMessage":"styles_iddleMessage__22yTN"};